import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState } from "react";
import { UserPlus } from "lucide-react";
import { AddUserModal } from "./AddUserModal";
import { Button } from "@/components/ui";
export const AddUserSection = ({ onAddUser, isLoading })=>{
    const [showCreateModal, setShowCreateModal] = useState(false);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(Button, {
                variant: "simple",
                color: "navy-90",
                className: "inline-flex items-center",
                onClick: ()=>setShowCreateModal(true),
                disabled: isLoading,
                children: [
                    /*#__PURE__*/ _jsx(UserPlus, {
                        className: "mr-2 h-4 w-4"
                    }),
                    "Add User"
                ]
            }),
            /*#__PURE__*/ _jsx(AddUserModal, {
                isOpen: showCreateModal,
                onClose: ()=>setShowCreateModal(false),
                onSubmit: onAddUser,
                isLoading: isLoading
            })
        ]
    });
};
